import loadInfoVariantAction from 'modules/variant/redux/actions/load-info'
import loadCartItemByVariantIdProductVariantAction from 'modules/product-variant/redux/actions/load-cart-item-by-variant-id'

/**
 * @param productVariant
 * @param price
 * @param variantId
 * @returns {(function(*): void)|*}
 */
export default function loadProductCollectionItemCardLoadAction ({
  productVariant,
  price,
  variantId
}) {
  return (dispatch) => {
    dispatch(
      loadInfoVariantAction({
        productId: productVariant.product_id,
        variantId,
        variantPrice: price,
        variantSku: productVariant.sku
      })
    )

    dispatch(
      loadCartItemByVariantIdProductVariantAction({
        variantId,
        productVariant
      })
    )
  }
}
